import { Observable } from "rxjs";
import { SpinnerModalService } from "../services/spinner-modal.service";
import { SpinnerPageService } from "../services/spinner-page.service";
import { effect, signal } from "@angular/core";

export class SpinnerComponentModel{
    message = signal<string>('');
    isLoading$:Observable<boolean> = new Observable();
    TRUE:boolean = true;
    constructor(service:SpinnerModalService | SpinnerPageService){
        this.isLoading$ = service.spinner$;

        effect(()=>{
            this.message.set(service.message());
        })
    }
}